import moment from 'moment'
// import CryptoJS from "crypto-js"
import BigNumber from "bignumber.js"
import md5 from 'js-md5'
const Iban = require('../assets/web3-eth-iban/src/index')
// require Iban from 'web3-eth-iban'
export default {
    install(Vue, opt) {
        Vue.prototype.tableHeaderColor = function ({
            row,
            column,
            rowIndex,
            columnIndex
        }) {
            if (rowIndex === 0) {
                return 'background-color:#F5F5F5 ;color: #333;font-weight: 600;font-size: 15px;height:58px;'
            }
        }
        Vue.prototype.timestampToTime = function (timestamp) {
            let time = ''
            if (timestamp == '' || timestamp == null || timestamp == undefined) {
                time = ''
            } else {
                time = moment(timestamp * 1000).format('YYYY-MM-DD HH:mm:ss')
            }
            return time
        }
        Vue.prototype.timestampToTime_1 = function (timestamp) {
            let time = ''
            if (timestamp == '' || timestamp == null || timestamp == undefined) {
                time = ''
            } else {
                time = moment(timestamp * 1000).format('YYYY-MM-DD')
            }
            return time
        }
        // Vue.prototype.passwordEncryption = function (e) {
        //     let cipherText = CryptoJS.HmacSHA1(e, '87krsC!IPF@OBRPEOh#Uat9C').toString(CryptoJS.enc.Hex);
        //     return cipherText;
        //
        // }
        Vue.prototype.md5Password = function (e) {
            // let cipherText = CryptoJS.HmacSHA1(e, '87krsC!IPF@OBRPEOh#Uat9C').toString(CryptoJS.enc.Hex);
            let pas = md5(e)
            return pas;

        }
        Vue.prototype.scientificCounting = function (e) {
            let num = 0
            if (e == 0 || e == '' || e == null || e == undefined || e == NaN) {
                num = 0
            } else {
                num = new BigNumber(`${e}`).div("1e+18").toString(10);
            }
            return num
        }
        //0x  -> th
        Vue.prototype.to_32_decimal = function (e) {
            let ban = ''
            if (e == '' || e == undefined) {
                ban = ''
            } else {
                ban = Iban.default.toIban(e);
            }
            return ban
        }
        Vue.prototype.to_16_decimal = function (e) {
            let ban = ''
            if (e == '' || e == undefined) {
                ban = ''
            } else {
                ban = Iban.default.toAddress(e).toLowerCase()
                // ban= Iban.default.toAddress(e)
            }
            return ban
        }
        Vue.prototype.change_Zh = function (e) {
            let splitName = e.split(",")
            // console.log("切割",e)

            if (e.indexOf(",") != -1) {
                // console.log("有逗号",this.$store.state.app.language)

                if (this.$store.state.app.language == 'zh') {
                    splitName = splitName[0]
                } else {
                    splitName = splitName[1]
                }

            } else {
                splitName = splitName[0]
                // console.log("没逗号")

            }
            return splitName
        }
        Vue.prototype.change_EN = function (e) {
            let splitName = e.split(",")
            // console.log("切割",e)

            // if(e.indexOf(",") != -1){
            //     // console.log("有逗号",this.$store.state.app.language)

            //     if(this.$store.state.app.language=='zh'){
            //         splitName = splitName[0]
            //     }else{
            //         splitName = splitName[1]
            //     }

            // }else {
            //     splitName = splitName[0]
            //     // console.log("没逗号")

            // }
            return splitName
        }

           /*16进制转32进制*/
    Vue.prototype.to32Decimal = function (e) {
        let ban = ''
  
        if (e == '' || e == undefined) {
          ban = ''
        } else {
          ban = Iban.default.toIban(e);
        }
        return ban
      }
      /*32进制转16进制*/
      Vue.prototype.to16Decimal = function (e) {
          let ban;
  
          if (e === 'TH48000000000000000000000000001EKI') {
            return '0x0000000000000000000000000000000000010002';
          }
          if (e == '' || e == undefined) {
            ban = ''
          } else {
            ban = Iban.default.toAddress(e).toLowerCase()
            // ban= Iban.default.toAddress(e)
          }
          return ban
        },
        Vue.prototype.transformAddress = function (val, type) { //type值必须传TH或者0x哦
          let is32Decimal = /^TH/g.test(val)
          if (type == 'TH' && !is32Decimal) {
            val = this.to32Decimal(val)
            console.log('我把他转成了TH')
          }
          if (type == '0x' && is32Decimal) {
            val = this.to16Decimal(val)
            console.log('我把他转成了0x')
          }
          return val
        }
      Vue.prototype.isTHAddress = function (address) { // 判断TH地址是否正确
        return Iban.default.isValid(address);
      }
  
      Vue.prototype.is0xAddress = function (address) { // 判断0x地址是否正确
        let reg = /^0[Xx][A-Fa-f0-9]+$/;
        return reg.test(address)
      }
      Vue.prototype.is0xTH = function (address) { // 判断0x地址是否正确
        let is16Decimal = /^0x/g.test(address)
        if (!is16Decimal) {
          address = this.to16Decimal(address)
          console.log('我把他转成了0x', address)
        }
        if (is16Decimal) {
          address = address.toLowerCase()
          console.log('我把他转成了小写', address)
        }
        return address
      }
    }

}